module.exports = __webpack_public_path__ + "media/images/ac_templates/201/dkcho-5528681140aef2b78417556f4b517bab.jpg";